(function() {
  if (new URLSearchParams(window.location.search).get('ref')) {
    var style = document.createElement('style');
    style.id = 'reseller-price-hide';
    style.textContent = '.price { visibility: hidden !important; }';
    document.head.appendChild(style);
  }
})();

(function () {
  var params = new URLSearchParams(window.location.search);
  var ref = params.get('ref');
  if (!ref) return;

  try {
    var padded = ref.replace(/-/g, '+').replace(/_/g, '/');
    var decoded = decodeURIComponent(escape(atob(padded)));
    var parts = decoded.split('|');
    var resellerPrice = parseFloat(parts[1]);
    if (!resellerPrice || resellerPrice <= 0) return;

    var formatted = '₹' + resellerPrice.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    function applyPrice() {
      document.querySelectorAll('.price-item, .price-item--regular, .price-item--sale').forEach(function(el) {
        el.textContent = formatted;
      });
      document.querySelectorAll('.price__compare, .price-item--compare, s.price-item').forEach(function(el) {
        el.style.display = 'none';
      });
      var hideStyle = document.getElementById('reseller-price-hide');
      if (hideStyle) hideStyle.remove();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyPrice);
    } else {
      applyPrice();
    }

    localStorage.setItem('flexora_ref', ref);
    localStorage.setItem('flexora_ref_price', resellerPrice.toString());
    localStorage.setItem('flexora_ref_time', Date.now().toString());

  } catch (e) {
    var hideStyle = document.getElementById('reseller-price-hide');
    if (hideStyle) hideStyle.remove();
  }
})();
